import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

export const constantRoutes = [
  { 
    path: '/login',
    component: () => import('@/pages/login'),
    hidden: true,
    meta:{
      title: '登录'
    }
  },
  { 
    path: '',
    component: Layout,
    hidden: true,
    redirect: '/login',
    children: [
      { 
        path: '/upData',
        name: 'upData',
        component: () => import('@/pages/upData'),
        meta: {
          title:'数据上传',
      	}
      },
      { 
        path: '/infoList',
        name: 'infoList',
        component: () => import('@/pages/infoList/index'),
        meta: {
          title:'信息列表',
        }
      },
      { 
        path: '/aiAnalysis',
        name: 'aiAnalysis',
        component: () => import('@/pages/aiAnalysis'),
        meta: {
          title:'AI分析',
        }
      },
      { 
        path: '/personalCenter',
        name: 'personalCenter',
        component: () => import('@/pages/personalCenter'),
        meta: {
          title:'个人中心',
      	  }
      },
      { 
        path: '/myShift',
        name: 'myShift',
        component: () => import('@/pages/myShift'),
        meta: {
          title: '我的排班',    
      	  }
      },
      {
        path: '/user',
        name: 'user',
        component: () => import('@/pages/userManage/userLayout'),
        redirect: '/user/muList',
        meta:{
           title:'用户管理'
        },
        children: [
          {
            path: 'userList',
            name: 'userList',
            component: () => import('@/pages/userManage/userList'),
            meta: {
              title: '医生列表',
              keepAlive: false
            }
          },
          {
            path: 'userAdd',
            name: 'userAdd',
            component: () => import('@/pages/userManage/userAdd'),
            meta: {
              title:'医生编辑',
              keepAlive: false,
              activeMenu:'/user/userList'
            }
          },
          {
            path: 'muList',
            name: 'muList',
            component: () => import('@/pages/userManage/muList'),
            meta: {
              title:'医联体列表',
              keepAlive: false
            }
          },
          {
            path: 'muAdd',
            name: 'muAdd',
            component: () => import('@/pages/userManage/muAdd'),
            meta: {
              title:'医联体编辑',
              keepAlive: false,
              activeMenu:'/user/muList'
            }
          },
          {
            path: 'hospitalList',
            name: 'hospitalList',
            component: () => import('@/pages/userManage/hospitalList'),
            meta: {
              title: '医院列表',
              keepAlive: false
            }
          },
          {
            path: 'hospitalAdd',
            name: 'hospitalAdd',
            component: () => import('@/pages/userManage/hospitalAdd'),
            meta: {
              title: '医院编辑',
              keepAlive: false,
              activeMenu:'/user/hospitalList'
            }
          }
        ]
      },
      {
        path: '/role',
        name: 'role',
        meta:{
           title: '权限管理'
        },
        component: () => import('@/pages/roleManage/roleLayout'),
        redirect: '/role/cloudAcc',
        children: [
          {
            path: 'cloudAcc',
            name: 'cloudAcc',
            component: () => import('@/pages/roleManage/roleAcc'),
            meta: {
              title: '云端账号',
              keepAlive: false
            }
          },
          {
            path: 'muAcc',
            name: 'muAcc',
            component: () => import('@/pages/roleManage/roleAcc'),
            meta: {
              title:'医联体账号',
              keepAlive: false
            }
          },
          {
            path: 'hospitalAcc',
            name: 'hospitalAcc',
            component: () => import('@/pages/roleManage/roleAcc'),
            meta: {
              title: '医院账号',
              keepAlive: false
            }
          }
        ] 
      },
      {
        path: '/statistics',
        name: 'statistics',
        component: () => import('@/pages/roleManage/roleLayout'),
        redirect: '/statistics/status',
        meta: {
          title:'BI统计分析'
        },
        children: [
          {
            path: 'status',
            name: 'status',
            component: () => import('@/pages/statistics/status'),
            meta: {
              title:'服务进度统计分析',
              keepAlive: false
            }
          },{
            path: 'quality',
            name: 'quality',
            component: () => import('@/pages/statistics/status'),
            meta: {
              title:'服务质量统计分析',
              keepAlive: false
            }
          },
          {
            path: 'editReport',
            name: 'editReport',
            component: () => import('@/pages/statistics/amount'),
            meta: {
              title:'编写报告服务量统计分析',
              keepAlive: false
            }
          },
          {
            path: 'checkReport',
            name: 'checkReport',
            component: () => import('@/pages/statistics/amount'),
            meta: {
              title:'编写报告服务量统计分析',
              keepAlive: false
            }
          },
        ] 
      },
    ]
  },
  {
    path: '',
    component: () => import('@/pages/layout_s'),
    hidden: true,
    children: [
      { // 选择用户身份
        path: '/chooseUser',
        component: () => import('@/pages/chooseUser'),
      },
      { // 报告
        path: '/infoList/report',
        component: () => import('@/pages/report/index'),
        meta: {
          title:'报告'
        }
      },
      { // 报告模板编辑
        path: '/infoList/report/editTemplate',
        component: () => import('@/pages/editTemplate'),
        meta: {
          title:'模板编辑'
        }
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/pages/404'),
    hidden: true
  },
  { path: '*', redirect: '/404', hidden: true }

]

// 左侧导航栏路由表(需要权限id)
export const asyncRoutes = [
  {
    path: '/upData',
    meta: {
      id: 300001,
      title: '数据上传',
      icon: 'data'
    },
    children: []
  },
  {
    path: '/infoList',
    meta: {
      id: 600001,
      title: '信息列表',
      icon: 'list'
    },
    children: []
  },
  { 
    path: '/aiAnalysis',
    name: 'aiAnalysis',
    component: () => import('@/pages/aiAnalysis'),
    meta: {
      id:210001,
      title:'AI分析',
      icon: 'aiAnalysis'
    },
    children: []
  },
  {
    path: 'user',
    meta: {
      id: 500001,
      title: '用户管理',
      icon: 'peoples'
    },
    children: [
      {
        path: '/user/muList',
        meta: {
          id: 700001,
          title: '医联体列表'
        },
        children: []
      },
      {
        path: '/user/hospitalList',
        meta: {
          id: 800001,
          title: '医院列表'
        },
        children: []
      },
      {
        path: '/user/userList',
        meta: {
          id: 900001,
          title: '医生列表'
        },
        children: []
      }
    ]
  },
  {
    path: 'role',
    meta: {
      id: 400001,
      title: '权限管理',
      icon: 'lock'
    },
    children: [
      {
        path: '/role/cloudAcc',
        meta: {
          id: 110001,
          title: '云端账号'
        },
        children: []
      },
      {
        path: '/role/muAcc',
        meta: {
          id: 120001,
          title: '医联体账号'
        },
        children: []
      },
      {
        path: '/role/hospitalAcc',
        meta: {
          id: 130001,
          title: '医院账号'
        },
        children: []
      }
    ]
  },
  {
    path: '/myShift',
    meta: {
      id: 140002,
      title: '我的排班',
      icon: 'shift'
    },
    children: []
  },
  { //服务统计
    path: '/statistics',
    meta: {
      id: 190001,
      title: 'BI统计分析',
      icon: 'statistics'
    },
    children: [
      // {
      //   // 服务状态
      //   path: 'status',
      //   meta: {
      //     id: 190002,
      //     title: '服务进度统计分析'
      //   },
      // },
      {
        path: 'editReport',
        meta: {
          id: 190002,
          title: '编写报告服务统计'
        },
      },
      {
        path: 'checkReport',
        meta: {
          id: 190002,
          title: '审核报告服务统计'
        },
      },
    ]
  },
  {
    path: '/personalCenter',
    meta: {
      id: 140001,
      title: '个人中心',
      icon: 'user'
    },
    children: []
  },
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
